import type { FC } from "react";
import { isDevelopmentEnvironment } from "@/common/helpers/environment.helper";
import { DeviceOptionsScenarioPicker } from "@/simulation/device-options/components/ScenarioPicker/scenario-picker";
import {
  MockDeviceOptionsService,
  SCENARIO_QUERY_PARAM,
} from "@/simulation/device-options/mock-device-options-service";
import { cachedAdapters, resolveServiceMode, type ServiceMode } from "@/services/service-mode";
import { HttpDeviceOptionsService } from "./device-options.http-adapter";
import type { DeviceOptionsService } from "./device-options-service";

export type DeviceOptionsServiceMode = ServiceMode;

export const resolveDeviceOptionsServiceMode = (hostname?: string, search?: string): ServiceMode =>
  resolveServiceMode([SCENARIO_QUERY_PARAM], hostname, search);

const buildAdapter = (mode: ServiceMode): DeviceOptionsService =>
  mode === "simulation" ? new MockDeviceOptionsService() : new HttpDeviceOptionsService();

const createModeSwitchingService = (): DeviceOptionsService => {
  const adapterFor = cachedAdapters(buildAdapter);
  return {
    getOptions: (params) => adapterFor(resolveDeviceOptionsServiceMode()).getOptions(params),
  };
};

export const createDeviceOptionsService = (mode?: ServiceMode): DeviceOptionsService =>
  mode ? buildAdapter(mode) : createModeSwitchingService();

const NoDevTools: FC = () => null;

export const devToolsFor = (hostname: string): FC =>
  isDevelopmentEnvironment(hostname) ? DeviceOptionsScenarioPicker : NoDevTools;

export const DeviceOptionsDevTools: FC = devToolsFor(window.location.hostname);
